/**
 * Page Clients
 * Wrapper pour le CustomersDashboard
 */

import React from 'react';
import { CustomersDashboard } from '../components/customers';

const CustomersPage: React.FC = () => {
    return <CustomersDashboard />;
};

export default CustomersPage;
